// Group data by period (month/year) and compute weighted average for a value field
export function getWeightedAverageGradeByDate(data, dateField, tonnageField, gradeField, periodType = 'month') {
  if (!Array.isArray(data) || data.length === 0) return [];
  const groups = {};
  data.forEach(row => {
    const dateStr = row[dateField];
    if (!dateStr) return;
    let periodKey;
    if (periodType === 'month') {
      // Expect DD/MM/YYYY or YYYY-MM-DD
      let d, m, y;
      if (dateStr.includes('/')) {
        [d, m, y] = dateStr.split('/').map(Number);
      } else if (dateStr.includes('-')) {
        [y, m, d] = dateStr.split('-').map(Number);
      }
      periodKey = `${y}-${String(m).padStart(2, '0')}`;
    } else if (periodType === 'year') {
      let y;
      if (dateStr.includes('/')) {
        y = dateStr.split('/')[2];
      } else if (dateStr.includes('-')) {
        y = dateStr.split('-')[0];
      }
      periodKey = `${y}`;
    } else {
      periodKey = dateStr;
    }
    if (!groups[periodKey]) {
      groups[periodKey] = { totalTonnage: 0, weightedSum: 0, count: 0, period: periodKey };
    }
    const tonnage = parseFloat(row[tonnageField]) || 0;
    const grade = parseFloat(row[gradeField]) || 0;
    groups[periodKey].totalTonnage += tonnage;
    groups[periodKey].weightedSum += tonnage * grade;
    groups[periodKey].count++;
  });
  return Object.values(groups).map(g => ({
    period: g.period,
    totalTonnage: g.totalTonnage,
    weightedAverage: g.totalTonnage > 0 ? g.weightedSum / g.totalTonnage : 0,
    count: g.count
  })).sort((a, b) => a.period.localeCompare(b.period));
}

// Example: group by date and sum tonnage/grade/content
export function summarizeDataByDate(data, dateField, fieldsToSum = []) {
  if (!Array.isArray(data) || data.length === 0) return [];
  const groups = {};
  data.forEach(row => {
    const dateStr = row[dateField];
    if (!dateStr) return;
    if (!groups[dateStr]) {
      groups[dateStr] = { [dateField]: dateStr };
      fieldsToSum.forEach(f => { groups[dateStr][f] = 0; });
    }
    fieldsToSum.forEach(f => {
      groups[dateStr][f] += parseFloat(row[f]) || 0;
    });
  });
  return Object.values(groups);
}
